"use client";

import styles from "./HomeHeader.module.css";
import Image from "next/image";
import { useState, useEffect, useContext } from "react";
import DynamicCarousel from "../new-components/DynamicCarousel";
import promoData from "../../data/header-promos.json";
import ScrollingBanner from "../scrollingBanner/ScrollingBanner";
import MobileBanner from "../mobile-banner/MobileBanner";
import { Poppins } from "next/font/google";
import HeaderCoupon from "../header-coupon/HeaderCoupon";
import QuickDepositSection from "../QuickDepositSection";
import { AppContext } from "@/src/context/AppContext";

const poppins = Poppins({
  subsets: ["latin"],
  style: ["normal", "italic"],
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  variable: "--font-poppins",
  display: "swap",
});

export default function HomeHeader() {
  const { user } = useContext(AppContext);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 450);
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mainPromo = promoData[0]; // koristimo samo centralnog "goata"

  if (user) {
    return (
      <div
        className={`${styles.HomeHeader} ${styles.withQuickDeposit} HomeHeader--withQuickDeposit ${poppins.variable} NoSelect`}
        id="HomeHeader"
      >
        <div className={styles.heroArea}>
          <div
            className={`${styles.heroRow} ${styles.heroRowEmpty}`}
            aria-hidden="true"
          />
          <div className={styles.quickDepositWrap}>
            <QuickDepositSection />
          </div>
        </div>

        {/* Keep guest promos visible for logged-in users — carousel/side promo only on phone */}
        <div className={styles.loggedInPromos}>
          <ScrollingBanner />
          {isMobile ? (
            <div className={styles.loggedInPromoSide}>
              <MobileBanner />
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.HomeHeader} ${poppins.variable}`}>
      <Image
        src="/new-site/confetti.png"
        alt="Goat"
        className={styles.ImgConfetti}
        width={1440}
        height={700}
        priority
      />

      <div className={styles.ContLayer_1}>
        <Image
          src={mainPromo.goatSrc}
          alt="Goat"
          className={styles.ImgGoatCenter}
          width={720}
          height={700}
          priority
          key={mainPromo.id}
        />
      </div>

      <div className={styles.ContLayer_2}>
        {/* COL LEFT – sada je dinamički kupon po klasi */}
        <div className={styles.ColBox_L}>
          <div className={styles.CPromosBox}>
            <div className={styles.ContImgPromos}>
              {/* <HeaderCoupon variant="desktop" /> */}
              <HeaderCoupon />
            </div>
          </div>
        </div>

        <ScrollingBanner />

        {/* COL RIGHT – guest: vertical carousel on desktop, MobileBanner on phone */}
        <div className={styles.ColBox_R}>
          {isMobile ? <MobileBanner /> : <DynamicCarousel />}
        </div>
      </div>
    </div>
  );
}
